import {
  Card,
  Button,
  Badge,
  ButtonGroup,
} from "react-bootstrap";
import moment from "moment-timezone";
import "moment/locale/es";
import constantes from "../../../../lib/constantes";

import "./style.css";

const PedidoCard = ({
  pedido,
  cardIndex,
  total,
  scrollToIndex,
  onEntregaClick,
  onNoEntregaClick,
  onVerEntregaClick,
  editable,
}) => {
  const {
    identifier,
    wsg_status: estadoActual,
    status: estadoActualNombre,
    substatus,
    fecha_entrega,
  } = pedido;

  const {
    shipping_first_name: first_name,
    shipping_last_name: last_name,
    shipping_address_1: address,
    shipping_address_2: complement,
    shipping_city: commune,
    shipping_phone: phone,
    shipping_state: region,
    customer_note: nota,
  } = pedido.vista_pedidos[0];

  const bgColor =
    estadoActual === constantes.WSG_STATUS.ENTREGADO
      ? "card-entregado"
      : estadoActual === constantes.WSG_STATUS.NO_ENTREGADO
      ? "card-no-entregado"
      : "";

  return (
    <Card className={`card-ruta ${bgColor}`}>
      <Card.Body>
        {/* <div className="d-flex justify-content-between mb-2">
          <Button
            variant="outline-secondary"
            onClick={handlePrev}
            disabled={cardIndex === 0}
          >
            <i className="bi bi-arrow-left-circle-fill fs-5"></i>
          </Button>
          <Button
            variant="outline-secondary"
            onClick={handleNext}
            disabled={cardIndex === total - 1}
          >
            <i className="bi bi-arrow-right-circle-fill fs-5"></i>
          </Button>
        </div> */}

        <div className="d-flex justify-content-between align-items-center mb-0">
          {/* <div>
            <Badge bg="primary" className="me-2">
              {identifier}
            </Badge>
          </div> */}
          <Card.Text className="card-titulo">{identifier}</Card.Text>
          {/* <Badge bg="light" text="dark">
            #{cardIndex + 1}
          </Badge> */}
        </div>

        <div className="mb-1">
          <Card.Text className="card-titulo mb-1">
            {first_name} {last_name}
          </Card.Text>
          <Card.Text className="card-direccion mb-1">
            Dirección: {address}, Dpto/Casa: {complement}, Comuna: {commune} -{" "}
            {region}
          </Card.Text>
          {nota && <Card.Text>Nota del cliente: {nota}</Card.Text>}

          {fecha_entrega && (
            <Card.Text className="mb-1">
              <span className="card-fecha">
                {moment(fecha_entrega)
                  .tz("America/Santiago")
                  .locale("es")
                  .format("ddd, D MMM YYYY HH:mm")
                  .replace(/^./, (c) => c.toUpperCase())}
              </span>
            </Card.Text>
          )}

          <Card.Text className="mb-0">
            {estadoActual === constantes.WSG_STATUS.ENTREGADO && (
              <Badge bg="success" className="badge-estado badge-entregado">
                {estadoActualNombre}
              </Badge>
            )}
            {estadoActual === constantes.WSG_STATUS.NO_ENTREGADO && (
              <Badge bg="danger" className="badge-estado badge-en-conserjeria">
                {estadoActualNombre}
              </Badge>
            )}
            {substatus !== 'undefined' && (
              <Badge bg="badge-estado badge-en-conserjeria">
                {substatus}
              </Badge>
            )}
            {!estadoActual && (
              <Badge bg="warning" className="badge-estado">
                Pendiente
              </Badge>
            )}
          </Card.Text>
        </div>
        {editable && (
          <>
            <div className="d-flex justify-content-center mb-2">
              <ButtonGroup>
                {(!estadoActual ||
                  estadoActual !== constantes.WSG_STATUS.ENTREGADO) && (
                  <Button
                    className="btn-accion btn-entregado"
                    size="sm"
                    onClick={() => onEntregaClick(pedido)}
                  >
                    Entregado
                  </Button>
                )}
                {estadoActual !== constantes.WSG_STATUS.ENTREGADO &&
                  estadoActual !== constantes.WSG_STATUS.NO_ENTREGADO && (
                    <Button
                      className="btn-accion btn-noentregado"
                      size="sm"
                      onClick={() => onNoEntregaClick(pedido)}
                    >
                      No entregado
                    </Button>
                  )}
              </ButtonGroup>
            </div>
          </>
        )}
        {editable && (
          <>
            <div className="d-flex justify-content-center mb-1">
              <ButtonGroup>
                {estadoActual !== constantes.WSG_STATUS.ENTREGADO && (
                  <>
                    <Button
                      variant="outline-secondary"
                      size="md"
                      href={`tel:${phone}`}
                    >
                      📞 Llamar
                    </Button>
                    <Button
                      variant="outline-secondary"
                      size="md"
                      href={`https://wa.me/${phone}`}
                    >
                      💬 WhatsApp
                    </Button>

                    <Button
                      variant="outline-secondary"
                      size="md"
                      onClick={() => onVerEntregaClick(pedido)}
                    >
                      🔍 Ver
                    </Button>
                  </>
                )}
              </ButtonGroup>
            </div>
          </>
        )}
        {estadoActual === constantes.WSG_STATUS.ENTREGADO && (
          <div className="d-flex justify-content-center mb-1">
            <ButtonGroup>
              <Button
                className="btn-accion btn-ver"
                onClick={() => onVerEntregaClick(pedido)}
              >
                🔍 Ver
              </Button>
            </ButtonGroup>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default PedidoCard;
